import { statusArray } from "./MaterialDetails";

export function libraryStatusFromSearch(value) {
  const status = String(value || "").trim().toLowerCase();
  return statusArray.includes(status) ? status : "";
}

export function libraryPathForStatus(status) {
  const next = libraryStatusFromSearch(status);
  return next ? `/library?status=${encodeURIComponent(next)}` : "/library";
}
